<template>
  <div>
    <div class="card-expansion">
      <md-card v-for="(commitment, idx) in commitments" :key="idx">
        <md-card-media>

        </md-card-media>

        <md-card-header>
          <div class="md-title">{{commitment.title}}</div>
          <div class="md-subhead">{{commitment.dueDate.toDate().toDateString()}}</div>
        </md-card-header>

        <md-card-expand>
          <md-card-actions md-alignment="space-between">
            <div>
              <md-button>Action</md-button>
              <md-button>Action</md-button>
            </div>

            <md-card-expand-trigger>
              <md-button class="md-icon-button">
                <md-icon>keyboard_arrow_down</md-icon>
              </md-button>
            </md-card-expand-trigger>
          </md-card-actions>

          <md-card-expand-content>
            <md-card-content>
              {{commitment.details}}
            </md-card-content>
          </md-card-expand-content>
        </md-card-expand>
      </md-card>

    </div>
    <md-button v-on:click="make_commitment" >Make new Commitment</md-button>
</div>
</template>

<script>

import { db } from '../main'
import firebase from 'firebase'

export default {
  name: 'FormValidation',
  data: () => ({
    commitments: []
  }),
  validations: {
  },
  methods: {
    make_commitment: function () {
      this.$router.replace('make_commitment')
    }
  },
  firestore () {
    var user = firebase.auth().currentUser
    var userdoc = db.collection('user').doc(user.uid)
    return {
      commitments: userdoc.collection('commitment').orderBy('dueDate')
    }
  }
}

</script>

<style lang="scss" scoped>

.card-expansion {
}

.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/Commitments.vue